import React from "react"
import "./src/styles/global.css"
import { RootWrapper } from "./src/components/root-wrapper"

export const wrapRootElement = ({ element }: any) => {
  return <RootWrapper element={element} />
}
